const config = {
    // Automatically use localhost in development, production URL in production builds
    baseUrl: process.env.NODE_ENV === 'development' 
      ? 'http://localhost:8080'
      : 'https://api.ohanabehavioralservice.com'
  };
  
  export default config;